import { PAGES } from 'common/enums';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { requestService } from 'services/requests-service/requests-service';
import { modifyTable } from './my-requests/utils';
import { IModifiedTableRow } from './my-requests/my-requests.props';
import { AxiosResponse } from 'axios';
import { ResponseModel } from 'common/interfaces';
import { IRepairPartnerItemsResponse } from 'services/requests-service/requests-service.props';

type IncidentByIdQueryOptions = Omit<
  UseQueryOptions<
    AxiosResponse<ResponseModel<Partial<IRepairPartnerItemsResponse>>>,
    Error,
    Partial<IModifiedTableRow>,
    [string, string]
  >,
  'queryKey' | 'queryFn' | 'select'
>;

export const useIncidentByIdQuery = (incidentId: string, options: IncidentByIdQueryOptions = DEFAULT_OPTIONS) => {
  const incidentByIdQuery = useQuery({
    queryKey: [PAGES.MY_REQUESTS, incidentId],
    queryFn: () => requestService.getRepairPartnerById(incidentId),
    ...options,
    enabled: !!incidentId,
    select: ({ data }) => modifyTable(data.data)
  });

  return {
    ...incidentByIdQuery,
    data: incidentByIdQuery?.data
  };
};

const DEFAULT_OPTIONS: IncidentByIdQueryOptions = {
  enabled: true
};
